const Number = (min, max, message) => {
    return (val) => {
        if (val < min) {
            return [
                false,
                message ?? `The value entered must be at least ${min}.`,
            ]
        }

        if (val > max) {
            return [
                false,
                message ?? `The value entered must be at most ${max}.`,
            ]
        }

        return [
            true,
            null,
        ]
    }
}

export default Number;
